import { useEffect, useRef } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
      } catch (e) {
        console.error("OAuth session exchange failed:", e);
      } finally {
        window.location.replace("/perfil");
      }
    };
    if (sessionId) run();
    else window.location.replace("/");
  }, [setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-cyan-400 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-heading text-lg">Verificando tu cuenta…</p>
      </div>
    </div>
  );
}
